import { NeuralIcon } from './agent/NeuralIcon';

interface FeatureGateProps {
  feature: 'mindmap' | 'agent' | 'duplicates';
  onBack: () => void;
}

const GATE_CONTENT = {
  mindmap: {
    title: 'Mind map is a Pro feature',
    description:
      "Explore your ideas as a D3 force-directed graph. See clusters, connections, and patterns that aren't visible in a list.",
    bullets: 'Force-directed graph \u00b7 Cluster detection \u00b7 Zoom & filter',
  },
  agent: {
    title: 'Agent chat is a Pro feature',
    description:
      'Talk to your ideas. AI-powered brainstorming, semantic connections, and context-aware conversations about your idea graph.',
    bullets: 'Semantic search \u00b7 Brainstorm clusters \u00b7 Context export',
  },
  duplicates: {
    title: 'Duplicate review is a Pro feature',
    description:
      'Every capture is checked against your existing ideas with semantic similarity. Pro unlocks the review queue \u2014 merge duplicates in one click or dismiss false positives.',
    bullets: 'Semantic matching \u00b7 One-click merge \u00b7 Nothing deleted',
  },
};

export function FeatureGate({ feature, onBack }: FeatureGateProps) {
  const content = GATE_CONTENT[feature];

  return (
    <div className="feature-gate">
      <div className="feature-gate-icon">
        <NeuralIcon size={64} />
      </div>
      <h2 className="feature-gate-title">{content.title}</h2>
      <p className="feature-gate-desc">{content.description}</p>
      <div className="feature-gate-preview">
        <div className="feature-gate-dots" />
      </div>
      <div className="feature-gate-bullets">{content.bullets}</div>
      <a href="/upgrade" className="feature-gate-cta">
        Upgrade to Pro &mdash; $7/mo
      </a>
      <button className="feature-gate-back" onClick={onBack}>
        &larr; back to ideas
      </button>
    </div>
  );
}
